import { __awaiter } from "tslib";
import React, { useEffect, useState } from 'react';
import { getLocale } from "@pb/utils/locale";
import { default as request } from "@pb/utils/request";
import { default as getCookie } from "@pb/utils/getCookie";
import constants from '../../constants';
import { errorHandler, mapRecommendationsToCarousel } from '../../helpers';
import { getDataFromUserCookie, getBpidFromCustomCookie, setCustomCookie, } from '../../helpers/cookie';
import { CarouselV1 as Carousel } from '../Carousel';
const getPartnerData = () => {
    const cookieData = getDataFromUserCookie();
    const storedBpid = getBpidFromCustomCookie();
    let { bpid } = cookieData;
    const { customerKey } = cookieData;
    if (!bpid) {
        bpid = storedBpid;
    }
    else if (storedBpid !== bpid) {
        setCustomCookie(bpid);
    }
    return {
        bpid,
        customerKey,
    };
};
const PersonalizedContainerV1 = ({ className, praConfiguration, maxarticles, categories, disablefavorites, minarticles, carouseltitle, imagetype, externalonly, brandfilter, breakpoint, }) => {
    const [showCarousel, setShowCarousel] = useState(false);
    const [modelInfo, setModelInfo] = useState('');
    const [originSource, setOriginSource] = useState('');
    const [finalProducts, setProducts] = useState([]);
    const afterFetch = ({ articles, origin, info }) => {
        if (articles && articles.length > 0) {
            const finalSet = mapRecommendationsToCarousel({
                articles,
                disableFavorites: disablefavorites === undefined ? true : disablefavorites,
                praConfiguration,
            });
            if (finalSet.length >= Number(minarticles)) {
                setModelInfo(info || '');
                setOriginSource(origin || '');
                setProducts(finalSet);
                setShowCarousel(true);
            }
        }
    };
    const fetchRecommendations = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const { bpid, customerKey } = getPartnerData();
            if (bpid) {
                const agcValue = getCookie('agCookie');
                const apiKey = process.env.PRA_PROD_RECO_KEY;
                const locale = getLocale(null, 'en_gb', null, { useAEMLocaleInfo: true });
                const domain = process.env.API_DOMAIN_PRA;
                const timeout = constants.API.TIMEOUT;
                const path = `/recos/v1/${locale.toLowerCase()}/articles`;
                let queryParams = `?apiKey=${apiKey}&partnerId=${bpid}&numberOfArticles=${maxarticles}`;
                if (categories) {
                    queryParams += `&categories=${categories}`;
                }
                if (agcValue) {
                    queryParams += `&agc=${agcValue}`;
                }
                if (customerKey) {
                    queryParams += `&ck=${customerKey}`;
                }
                if (brandfilter) {
                    queryParams += `&brands=${brandfilter}`;
                }
                if (externalonly) {
                    queryParams += `&externalonly=${externalonly}`;
                }
                const constructedURL = `${domain}${path}${queryParams}`;
                const { data } = yield request.get(constructedURL, { timeout });
                afterFetch(data);
            }
        }
        catch (error) {
            errorHandler(error);
        }
    });
    useEffect(() => {
        if (praConfiguration) {
            fetchRecommendations();
        }
    }, [maxarticles, categories, brandfilter, externalonly, praConfiguration]);
    if (!showCarousel) {
        return null;
    }
    return (React.createElement(Carousel, { className: className, finalProducts: finalProducts, praConfiguration: praConfiguration, modelInfo: modelInfo, origin: originSource, carouselTitle: carouseltitle, imageType: imagetype, breakpoint: breakpoint }));
};
export default PersonalizedContainerV1;
//# sourceMappingURL=PersonalizedContainerV1.js.map